const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class ContentGrid extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.333,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('content-grid')) {
  customElements.define('content-grid', ContentGrid)
}
